import { render, staticRenderFns } from "./OrgData.vue?vue&type=template&id=255481af&scoped=true"
import script from "./OrgData.vue?vue&type=script&lang=js"
export * from "./OrgData.vue?vue&type=script&lang=js"
import style0 from "./OrgData.vue?vue&type=style&index=0&id=255481af&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255481af",
  null
  
)

export default component.exports